import { storeCreator } from '@/utils/store/store.utils';

import { ReactivationSteps } from '../types';

interface State {
  modalVisible: boolean;
  planId?: string;
  planName?: string;
  planIds?: string[];
  planNames?: string[];
  isBulkMode: boolean;
  additionalAction?: () => void;
  step: ReactivationSteps;

  handleChangeVisibility: (value: boolean) => void;
  handleSetPlanId: (value?: string) => void;
  handleSetPlanName: (value?: string) => void;
  handleSetPlanIds: (value?: string[]) => void;
  handleSetPlanNames: (value?: string[]) => void;
  handleSetIsBulkMode: (value: boolean) => void;
  handleSetAdditionalAction: (value?: () => void) => void;
  handleSetStep: (value: ReactivationSteps) => void;
  handleReset: () => void;
}

export const usePlanReactivationModalStore = storeCreator<State>((set) => ({
  modalVisible: false,
  planId: undefined,
  planName: undefined,
  planIds: undefined,
  planNames: undefined,
  isBulkMode: false,
  additionalAction: undefined,
  step: ReactivationSteps.FORM,

  handleChangeVisibility: (value) => set((state) => ({ ...state, modalVisible: value })),
  handleSetPlanId: (value) => set((state) => ({ ...state, planId: value })),
  handleSetPlanName: (value) => set((state) => ({ ...state, planName: value })),
  handleSetPlanIds: (value) => set((state) => ({ ...state, planIds: value })),
  handleSetPlanNames: (value) => set((state) => ({ ...state, planNames: value })),
  handleSetIsBulkMode: (value) => set((state) => ({ ...state, isBulkMode: value })),
  handleSetAdditionalAction: (value) => set((state) => ({ ...state, additionalAction: value })),
  handleSetStep: (value) => set((state) => ({ ...state, step: value })),
  handleReset: () => set((state) => ({
    ...state,
    modalVisible: false,
    planId: undefined,
    planName: undefined,
    planIds: undefined,
    planNames: undefined,
    isBulkMode: false,
    additionalAction: undefined,
    step: ReactivationSteps.FORM,
  })),
}));
